// 音效对象
const sound = {
  install(vue, store) {
    this.store = store;
    vue.prototype.$Sound = sound;
  },
  store: null,
  // 验证是否能播放音效
  validate() {
    return false;
    // return this.store.state.efSound;
  },
  // 喂养音效
  playFeed() {
    if (this.validate()) {
      document.querySelector("#feed").play();
    }
  },
  // 收集水晶
  playCollect() {
    if (this.validate()) {
      document.querySelector("#collectCrystal").play();
    }
  },
};

export default sound;
